export const getSegmentId = (): string => {
  return (
    window.analytics?.user?.()?.anonymousId?.() ||
    localStorage.getItem('ajs_anonymous_id') ||
    'unknown'
  )
}
